import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import Why from "@/pages/Why";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Accessibility from "@/pages/Accessibility";
import Method from "@/pages/Method";
import HousingDomain from "@/pages/solutions/HousingDomain";
import MentalHealthDomain from "@/pages/solutions/MentalHealthDomain";
import AgingDisabilityDomain from "@/pages/solutions/AgingDisabilityDomain";
import HealthCareDomain from "@/pages/solutions/HealthCareDomain";
import AU from "@/pages/AU";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/dashboard/Login";
import AdminDashboard from "@/pages/dashboard/Dashboard";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Marketing routes (use shared Layout with Header/Footer) */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/why" element={<Why />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/method" element={<Method />} />

            {/* Four domains of care */}
            <Route path="/solutions/housing" element={<HousingDomain />} />
            <Route path="/solutions/mental-health" element={<MentalHealthDomain />} />
            <Route path="/solutions/aging-disability" element={<AgingDisabilityDomain />} />
            <Route path="/solutions/health-care" element={<HealthCareDomain />} />

            {/* Retired routes — SPA-side redirects (Netlify 301s cover inbound links) */}
            <Route path="/solutions/hna" element={<Navigate to="/solutions/housing" replace />} />
            <Route path="/solutions/monitoring" element={<Navigate to="/solutions/housing#monitoring" replace />} />
            <Route path="/solutions/community" element={<Navigate to="/platform#service-landscape" replace />} />
            <Route path="/solutions/disparity" element={<Navigate to="/platform#service-landscape" replace />} />
            <Route path="/pricing" element={<Navigate to="/solutions/housing#pricing" replace />} />
            <Route path="/demo" element={<Navigate to="/contact" replace />} />

            <Route path="/au" element={<AU />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Internal dashboard at /app (no marketing chrome) */}
          <Route path="/app/login" element={<AdminLogin />} />
          <Route path="/app" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
